import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransactionalEmailsComponent } from './transactional-emails.component';

const routes: Routes = [
  {
    path: '',
    component: TransactionalEmailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TransactionalEmailsRoutingModule {}
